<script setup lang="ts" generic="Item extends PolicyMenuItem">
import type { PolicyMenuItem } from '~/components/menu/MenuTypes';
import MenuLink from '~/components/menu/MenuLink.vue';

defineProps<{
  title?: string,
  icon: string[],
  links: Item[],
  link?: string,
  isSelected: boolean,
}>();
</script>

<template>
  <div
    :class="[
      'policies-container text-sm',
      { 'font-semibold': isSelected },
    ]"
  >
    <NuxtLink
      v-if="link"
      :href="link"
      :class="[
        'mt-4 relative hover:text-primary-600 hover:font-semibold hover:transition-100',
        { 'text-primary-600': isSelected },
      ]"
    >
      <UiFaIcon :icon="icon" />
      <span class="ml-2">
        <slot name="title">
          {{ title }}
        </slot>
      </span>
    </NuxtLink>
    <span v-else :class="{ 'text-primary-600': isSelected }">
      <UiFaIcon :icon="icon" />
      <h2 class="ml-2 inline-block">
        <slot name="title">
          {{ title }}
        </slot>
      </h2>
    </span>
    <div class="ml-8 mt-2">
      <ul>
        <MenuLink
          v-for="menuLink in links"
          :key="menuLink.name"
          class="mt-4"
          :link="menuLink"
        >
          <template #link-name>
            <slot name="link-name" v-bind="menuLink">
              {{ menuLink.name }}
            </slot>
          </template>
        </MenuLink>
      </ul>
    </div>
  </div>
</template>
